import { Banner, InfoIcon, Typography } from '@iheartjane/reefer';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';

// URL flag (`?ineligible=true`) set by the consumer when a Gold
// deal is not available to the user. The banner reads it on mount and strips it.
export const JANE_GOLD_INELIGIBLE_QUERY_KEY = 'ineligible';

export function IneligibleDealBanner() {
  const [searchParams] = useSearchParams();

  // Capture the param once on mount; banner visibility is local-only from
  // here. Combined with the URL-strip effect below, this means a reload,
  // back-button navigation, or shared URL won't re-trigger the banner.
  const [shouldShow] = useState(
    () => searchParams.get(JANE_GOLD_INELIGIBLE_QUERY_KEY) === 'true'
  );

  // Use history.replaceState (not setSearchParams) so the URL cleanup doesn't
  // count as a navigation.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    if (url.searchParams.has(JANE_GOLD_INELIGIBLE_QUERY_KEY)) {
      url.searchParams.delete(JANE_GOLD_INELIGIBLE_QUERY_KEY);
      window.history.replaceState({}, '', url.toString());
    }
  }, []);

  if (!shouldShow) return null;

  return (
    <Banner
      full
      icon={<InfoIcon />}
      label={
        <Typography variant="body-semibold">
          Sorry, you&apos;re not eligible for that Jane Gold deal. Shop these
          deals instead for cash back rewards.
        </Typography>
      }
      mb={8}
      mt={32}
      variant="info"
    />
  );
}
